export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-comment-quotes-1e0e48213b7c22cc8e933a98be624d1e.svg";